import Api from '@/common/fetch.js'
import { apiRoute } from '@/common/config'

let route = apiRoute + '/Config'

export default {
    getDiscounts (request) {
        return Api.post(route + '/Discounts', request)
    },
    addDiscount (request) {
        return Api.post(route + 'Discounts/Add', request)
    },
    editDiscount (request) {
        return Api.post(route + 'Discounts/Edit', request)
    },
    deleteDiscount (request) {
        return Api.post(route + 'Discounts/Delete', request)
    },

    getDiscountModules (request) {
        return Api.post(route + '/DiscountModules', request)
    },
    addDiscountModule (request) {
        return Api.post(route + 'DiscountModules/Add', request)
    },
    editDiscountModule (request) {
        return Api.post(route + 'DiscountModules/Edit', request)
    },
    deleteDiscountModule (request) {
        return Api.post(route + 'DiscountModules/Delete', request)
    },

    getCustomerGroup (request) {
        return Api.post(route + '/CustomerGroup', request)
    },
    addCustomerGroup (request) {
        return Api.post(route + 'CustomerGroup/Add', request)
    },
    editCustomerGroup (request) {
        return Api.post(route + 'CustomerGroup/Edit', request)
    },
    deleteCustomerGroup (request) {
        return Api.post(route + 'CustomerGroup/Delete', request)
    },

    getBlackList (request) {
        return Api.post(route + '/BlackList', request)
    },
    addBlackList (request) {
        return Api.post(route + 'BlackList/Add', request)
    },
    editBlackList (request) {
        return Api.post(route + 'BlackList/Edit', request)
    },
    deleteBlackList (request) {
        return Api.post(route + 'BlackList/Delete', request)
    },
}
